import { get, HTTP_HEADERS } from '@api/api';
import API_ROUTES from '@api/routes';
import { MeResponse } from 'types/login';

export const getMe = async () => {
	const res = await get<MeResponse>(API_ROUTES.v1.me);
	const csrfTokenFromHeader =
		(res.headers && res.headers[HTTP_HEADERS.csrf]) || '';
	return { user: res.data, csrfTokenFromHeader };
};
